import {useEffect, useRef, useState} from "react";
import {Line, Area} from '@antv/g2plot';
import {Spin, Button} from "antd";
import "./TransactionsLineChart.scss";
import {APIv1} from "../../../../api";

const TransactionsLineChart = ({t}) => {
    const [userData, setUserData] = useState({});
    const chartRef = useRef(null);
    const linePlotRef = useRef(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeField, setActiveField] = useState("value");

    useEffect(() => {
        const items = JSON.parse(localStorage.getItem("user"));
        if (items) {
            setUserData(items);
        }
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await APIv1.get("analysis/transactions/periodic/summary/", {
                    headers: {
                        Authorization: `Token ${userData.token}`,
                    },
                });
                setData(response.data);
            } catch (error) {
                console.error("Error fetching transaction data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [userData.token]);

    useEffect(() => {
        if (chartRef.current && data.length > 0) {
            linePlotRef.current = new Line(chartRef.current, {
                data,
                xField: "day",
                yField: activeField,
                seriesField: "provider",
                yAxis: {
                    label: {
                        formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
                    },
                },
                tooltip: {
                    formatter: (datum) => ({
                        name: datum.provider,
                        value: datum[activeField].toLocaleString("en-US").replace(/,/g, " "),
                    }),
                },
                legend: {
                    position: "top",
                },
                smooth: true,
                area: {
                    style: {
                        fillOpacity: 0.15,
                    },
                },
                animation: {
                    appear: {
                        animation: 'wave-in',
                        duration: 3000,
                    },
                }
            });

            linePlotRef.current.render();
        }
    }, [data]);

    // Update Chart when switching "Value" <-> "Count"
    useEffect(() => {
        if (linePlotRef.current) {
            linePlotRef.current.update({
                yField: activeField,
                tooltip: {
                    formatter: (datum) => ({
                        name: datum.provider,
                        value: datum[activeField].toLocaleString("en-US").replace(/,/g, " "),
                    }),
                },
            });
        }
    }, [activeField]);

    return (
        <div className="analysis__chart-card analysis__chart-card--wide transactions-line-chart">
            <h3 className="analysis__chart-subtitle">
                {t("analysis.numbersStats.mainTitles.transactionsLineChartTitle")}
            </h3>

            <div className="transactions-line-chart__toggle">
                <Button type="primary" onClick={() => setActiveField(activeField === "value" ? "count" : "value")}>
                    {activeField === "value" ? `${t("analysis.charts.lineChart.count")}` : `${t("analysis.charts.lineChart.price")}`}
                </Button>
            </div>

            <div className={`transactions-line-chart__container ${loading ? "" : "loaded"}`}>
                {loading && (
                    <div className="transactions-line-chart__loading">
                        <Spin size="large"/>
                    </div>
                )}
                <div ref={chartRef} style={{height: "100%", width: "100%"}}></div>
            </div>
        </div>
    );
};

export default TransactionsLineChart;

